import { Component } from "@angular/core";
import { FieldType } from "@ngx-formly/core";

@Component({
  selector: "astrobin-formly-field-custom-number",
  templateUrl: "./formly-field-custom-number.component.html"
})
export class FormlyFieldCustomNumberComponent extends FieldType {}
